import Vue from 'vue' //引入 Vue
import VueRouter from 'vue-router'
import store from "@/store/store";
Vue.use(VueRouter); //安装插件

export const constantRouterMap = [
    {
        path: '/',
        redirect: '/login'
    },
    {path: '/login', component: () => import('@/views/login')},
    {path: '/main-page', component: () => import('@/views/main-page')},
    {path: '/scan', component: () => import('@/components/qrcode/index')},
    {path: '/detail', component: () => import('@/components/detail/index')},
    {path: '/checking', component: () => import('@/components/checking/index')},
    {path: '/task-list', component: () => import('@/components/tabs/task_list.vue')},
    {path: '/task-basic', component: () => import('@/components/tabs/task_basic.vue')},
]

const router = new VueRouter({
    // mode: 'history', //后端支持可开
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRouterMap //指定路由列表
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
    store.dispatch('clearCancel');
    next();
});

export default router;
